import { createDataCacheKeys, Customer, Page } from '~/data';
import { CustomerFilter, useCustomerApi, usePaginatedQuery, UsePaginatedQueryResult } from '~/data/api';

const cacheKeys = createDataCacheKeys('customers-picker');

const defaultPageObject: Page<Customer> = {
  items: [],
  page: 1,
  pages: 1,
  size: 1,
  total: 1,
};

type UserCustomersOptions = {
  filterBy?: CustomerFilter;
  size?: number;
  enabled?: boolean;
};

export type UseCustomersResult = UsePaginatedQueryResult<Customer>;

export const usePickerCustomers = (
  { filterBy, size, enabled = true }: UserCustomersOptions = {
    filterBy: undefined,
  }
): UseCustomersResult => {
  const api = useCustomerApi();

  const { data, isLoading, isError, isSuccess, error, fetchNextPage } = usePaginatedQuery<Customer>({
    cacheKey: [...cacheKeys.list({ filterBy })],
    enabled,
    fetchAll: (pageParams) =>
      api.getAll({ filter: filterBy, page: { page: pageParams.page, size: size || pageParams.size } }),
  });

  return {
    data: data || defaultPageObject,
    error,
    fetchNextPage,
    isError,
    isLoading,
    isSuccess,
  };
};
